module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Blood Before Dawn")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "copyright-page"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ii",
      "title": "ii"
    }
  }, [_c('i', [_vm._v("Blood Before Dawn, Book 2 in The Dung Beetles of Liberia series")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("© 2021 Daniel V. Meier, Jr. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("No part of this book may be reproduced in any form or by any means, electronic, mechanical, digital, photocopying, or recording, except for the inclusion in a review, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("While the story is based on real events, this is a work of fiction. All of the characters, names, incidents, organizations, and dialogue in this novel are either the products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Published in the United States by BQB Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("(an imprint of Boutique of Quality Books Publishing, Inc.)")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bqbpublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bqbpublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("978-1-952782-35-0 (p)")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("978-1-952782-36-7 (e)")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Library of Congress Control Number: 2021948707")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Book design by Robin Krauss, "), _c('a', {
    attrs: {
      "href": "http://www.bookformatters.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bookformatters.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Cover design by Rebecca Lown, "), _c('a', {
    attrs: {
      "href": "http://www.rebeccalowndesign.com",
      "target": "_blank"
    }
  }, [_vm._v("www.rebeccalowndesign.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Map illustrator: Rosana Keleber")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("First editor: Caleb Guard")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Second editor: Andrea Vande Vorde")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a70f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 60
// module chunks = 0